import React from 'react';
import { Link } from 'react-router-dom';

export const NotFound = () => {
  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f2f2f2',
      color: '#333',
      textAlign: 'center',
      padding: '20px'
    }}>
      <h1 style={{ fontSize: '100px', margin: '0', color: '#ff4d4f' }}>404</h1>
      <h2 style={{ fontSize: '28px', margin: '10px 0' }}>Page Not Found</h2>
      <p style={{ fontSize: '16px', marginBottom: '20px' }}>
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link to="/" style={{
        textDecoration: 'none',
        backgroundColor: '#d32f2f',
        color: '#fff',
        padding: '10px 20px',
        borderRadius: '5px',
        fontSize: '16px',
        transition: 'background 0.3s'
      }}>
        Go to Dashboard
      </Link>
    </div>
  );
};
